/* PagePilot-style product landing page — shared behaviour */
(function () {
  if (window.__ppLanding) return;
  window.__ppLanding = true;

  function each(scope, sel, fn) {
    Array.prototype.forEach.call(scope.querySelectorAll(sel), fn);
  }

  function once(el) {
    if (el.dataset.ppInit) return false;
    el.dataset.ppInit = '1';
    return true;
  }

  function stepSize(track) {
    var first = track.children[0];
    if (!first) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function atEnd(track) {
    return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  }

  function move(track, dir) {
    if (dir > 0 && atEnd(track)) return track.scrollTo({ left: 0 });
    if (dir < 0 && track.scrollLeft <= 4) return track.scrollTo({ left: track.scrollWidth });
    track.scrollBy({ left: dir * stepSize(track) });
  }

  /* Carousels (reviews, videos, product cards, gallery) */
  function initCarousels(scope) {
    each(scope, '[data-pp-carousel]', function (c) {
      if (!once(c)) return;
      var track = c.querySelector('[data-pp-track]');
      if (!track) return;
      var prev = c.querySelector('[data-pp-prev]');
      var next = c.querySelector('[data-pp-next]');
      if (prev) prev.addEventListener('click', function () { move(track, -1); });
      if (next) next.addEventListener('click', function () { move(track, 1); });

      // Hide arrows / dots and stop autoplay when every slide is already visible.
      var dotsWrap = c.parentNode.querySelector('.pp-dots');
      function fits() { return track.scrollWidth <= track.clientWidth + 4; }
      function checkFit() {
        var f = fits();
        c.classList.toggle('is-static', f);
        if (dotsWrap) dotsWrap.style.display = f ? 'none' : '';
      }
      checkFit();
      window.addEventListener('resize', checkFit);
      window.addEventListener('load', checkFit);

      var dots = c.parentNode.querySelectorAll('[data-pp-dot]');
      if (dots.length) {
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / stepSize(track));
          Array.prototype.forEach.call(dots, function (d, n) { d.style.opacity = n === i ? 1 : 0.35; });
        }, { passive: true });
      }

      var delay = parseInt(c.dataset.ppAutoplay, 10);
      if (delay > 0) {
        var paused = false;
        c.addEventListener('mouseenter', function () { paused = true; });
        c.addEventListener('mouseleave', function () { paused = false; });
        c.addEventListener('touchstart', function () { paused = true; }, { passive: true });
        setInterval(function () { if (!paused && !document.hidden && !fits()) move(track, 1); }, delay * 1000);
      }
    });
  }

  /* Product gallery thumbnails */
  function initGallery(scope) {
    each(scope, '[data-pp-gallery]', function (g) {
      if (!once(g)) return;
      var track = g.querySelector('[data-pp-track]');
      var thumbs = g.querySelectorAll('[data-pp-thumb]');
      function goTo(i) {
        var slide = track.children[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft });
      }
      Array.prototype.forEach.call(thumbs, function (t, i) {
        t.addEventListener('click', function () { goTo(i); });
      });
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        Array.prototype.forEach.call(thumbs, function (t, n) {
          t.classList.toggle('is-active', n === i);
          if (n === i && t.scrollIntoView && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
            t.parentNode.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
          }
        });
      }, { passive: true });
      g.ppGoToMedia = function (id) {
        Array.prototype.forEach.call(track.children, function (s, i) {
          if (String(s.dataset.mediaId) === String(id)) goTo(i);
        });
      };
    });
  }

  /* Variant picker + quantity */
  function initProduct(scope) {
    each(scope, '[data-pp-product]', function (root) {
      if (!once(root)) return;
      var dataEl = root.querySelector('[data-pp-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];

      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-pp-qty]');
        if (!btn) return;
        var input = root.querySelector('[data-pp-qty-input]');
        var val = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.ppQty, 10);
        input.value = Math.max(1, val);
      });

      root.addEventListener('change', function (e) {
        if (!e.target.matches('[data-pp-option]')) return;
        var selected = [];
        each(root, '[data-pp-option]:checked', function (i) { selected[+i.dataset.ppOption] = i.value; });
        each(root, '[data-pp-option-label]', function (l) { l.textContent = selected[+l.dataset.ppOptionLabel] || ''; });
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return o === selected[i]; });
        })[0];

        each(document, '[data-pp-atc]', function (btn) {
          var label = btn.querySelector('[data-pp-atc-text]');
          if (!v) {
            btn.disabled = true;
            if (label) label.textContent = btn.dataset.unavailable;
            return;
          }
          btn.disabled = !v.available;
          if (label) label.textContent = v.available ? btn.dataset.atc : btn.dataset.soldout;
        });
        if (!v) return;

        each(root, '[data-pp-variant-input]', function (i) { i.value = v.id; });
        each(document, '[data-pp-price]', function (el) { el.textContent = v.price; });
        each(document, '[data-pp-compare]', function (el) { var bk = el.getAttribute('data-pp-compare-backup') || ''; el.textContent = v.compare || bk; el.hidden = !(v.compare || bk); });
        each(document, '[data-pp-save]', function (el) { var c = document.querySelector('[data-pp-compare]'); el.hidden = !(v.save || (c && !c.hidden)); });
        each(document, '[data-pp-save-value]', function (el) { el.textContent = v.save; });

        if (v.media) {
          var g = root.querySelector('[data-pp-gallery]');
          if (g && g.ppGoToMedia) g.ppGoToMedia(v.media);
        }
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* Animated percentage circles */
  function initCircles(scope) {
    var circles = scope.querySelectorAll('[data-pp-circle]');
    if (!circles.length) return;
    function fill(el) { el.style.strokeDashoffset = el.dataset.ppCircle; }
    if (!('IntersectionObserver' in window)) return each(scope, '[data-pp-circle]', fill);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { fill(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.4 });
    Array.prototype.forEach.call(circles, function (c) { io.observe(c); });
  }

  /* Video carousel controls */
  function initVideos(scope) {
    each(scope, '[data-pp-video]', function (wrap) {
      if (!once(wrap)) return;
      var v = wrap.querySelector('video');
      if (!v) return;
      var wantSound = wrap.hasAttribute('data-pp-sound');
      v.muted = !wantSound;
      if (wantSound && v.autoplay) {
        var tryPlay = v.play();
        if (tryPlay && tryPlay.catch) tryPlay.catch(function () { v.muted = true; v.play().catch(function () {}); });
      }
      function sync() {
        wrap.classList.toggle('is-paused', v.paused);
        wrap.classList.toggle('is-unmuted', !v.muted);
      }
      v.addEventListener('play', sync);
      v.addEventListener('pause', sync);
      v.addEventListener('volumechange', sync);
      v.addEventListener('loadeddata', sync);
      function togglePlay() { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }
      var playBtn = wrap.querySelector('[data-pp-video-play]');
      var soundBtn = wrap.querySelector('[data-pp-video-sound]');
      if (playBtn) playBtn.addEventListener('click', function (e) { e.stopPropagation(); togglePlay(); });
      if (!v.controls) v.addEventListener('click', togglePlay);
      if (soundBtn) soundBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (v.muted) {
          each(document, '[data-pp-video] video', function (other) { if (other !== v) other.muted = true; });
          v.muted = false;
          if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else {
          v.muted = true;
        }
      });
      sync();
    });
  }

  /* Bundle cards: Ajax cart (skip cart) with sending / thank-you text and success message */
  function escapeHtml(t) {
    return String(t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildMessage(form) {
    var html = escapeHtml(form.dataset.message || '');
    html = html.replace(/\[cart label=([^\]]+)\]/g, '<a href="' + escapeHtml(form.dataset.cartUrl || '/cart') + '">$1</a>');
    html = html.replace(/\[continue label=([^\]]+)\]/g, '<a href="' + escapeHtml(form.dataset.continueUrl || '/collections/all') + '">$1</a>');
    return html;
  }

  /* EasySell popup: any element with the class below opens the EasySell COD form.
     PP buttons carrying it skip their own scroll / add-to-cart so only the popup runs. */
  var ES_CLASS = 'es-popup-button-overwrite';
  function isEasySell(el) { return !!(el && el.closest && el.closest('.' + ES_CLASS + ',.pp-cod-open,[data-pp-codopen]')); }

  /* Page popup for the COD form: the EasySell form (#easysell) is moved into the popup
     as soon as it appears, so it never shows on the page itself. */
  function codModal() { return document.querySelector('[data-pp-codmodal]'); }
  function codPullForm() {
    var m = codModal(); if (!m) return false;
    var body = m.querySelector('[data-pp-codbody]');
    var es = document.getElementById('easysell');
    if (body && es && !body.contains(es)) body.appendChild(es);
    return !!es;
  }
  function codOpen() {
    var m = codModal(); if (!m) return false;
    codPullForm();
    if (!window.Shopify || !Shopify.designMode) { if (m.parentNode !== document.body) document.body.appendChild(m); }
    m.hidden = false;
    document.documentElement.classList.add('pp-cod-lock');
    return true;
  }
  function codClose() {
    var m = codModal(); if (!m) return;
    m.hidden = true;
    document.documentElement.classList.remove('pp-cod-lock');
  }
  if (document.querySelector('[data-pp-codmodal]') || document.readyState === 'loading') {
    var codTries = 0;
    var codTimer = setInterval(function () {
      if (!codModal()) { if (document.readyState !== 'loading') clearInterval(codTimer); return; }
      if (codPullForm() || ++codTries > 120) clearInterval(codTimer);
    }, 250);
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-pp-codopen],.pp-cod-open');
    if (open && codModal()) { e.preventDefault(); codOpen(); return; }
    if (e.target.closest && e.target.closest('[data-pp-codclose]')) { e.preventDefault(); codClose(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') codClose(); });
  /* Theme editor: show the popup while its section or blocks are selected */
  document.addEventListener('shopify:section:select', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('[data-pp-codmodal]')) { var m = codModal(); if (m) m.hidden = false; } });
  document.addEventListener('shopify:block:select', function (e) { var m = e.target && e.target.closest && e.target.closest('[data-pp-codmodal]'); if (m) m.hidden = false; });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('[data-pp-codmodal]')) codClose(); });

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-pp-bundle-form]') : null;
    if (form && (isEasySell(e.submitter) || isEasySell(form.querySelector('[type="submit"]')))) { e.preventDefault(); return; }
    if (!form || form.dataset.ajax !== 'true') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (!btn || btn.disabled) return;
    var label = btn.querySelector('[data-pp-label]');
    var original = label ? (btn.dataset.label || label.textContent) : '';
    btn.dataset.label = original;
    var msg = form.parentNode.querySelector('[data-pp-msg]');
    if (msg) { msg.hidden = true; msg.classList.remove('ppb-msg--error'); }

    btn.disabled = true;
    btn.classList.add('is-busy');
    if (label && form.dataset.sending) label.textContent = form.dataset.sending;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(form.elements.id.value, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () {
        if (label && form.dataset.thanks) label.textContent = form.dataset.thanks;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (form.dataset.goto === 'stay') {
          if (msg && form.dataset.message) { msg.innerHTML = buildMessage(form); msg.hidden = false; }
          setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove('is-busy');
            if (label) label.textContent = original;
          }, 1500);
          return;
        }
        window.location.href = form.dataset.url || (root + 'checkout');
      })
      .catch(function (d) {
        btn.disabled = false;
        btn.classList.remove('is-busy');
        if (label) label.textContent = original;
        if (msg) {
          msg.textContent = (d && (d.description || d.message)) || 'Could not add to cart. Please try again.';
          msg.classList.add('ppb-msg--error');
          msg.hidden = false;
        }
      });
  });

  /* Reset buttons when shoppers come back from checkout with the browser back button */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    each(document, '[data-pp-bundle-form] [type="submit"]', function (b) {
      b.classList.remove('is-loading', 'is-busy');
      if (!b.hasAttribute('data-sold-out')) b.disabled = false;
      var l = b.querySelector('[data-pp-label]');
      if (l && b.dataset.label) l.textContent = b.dataset.label;
    });
  });

  /* Sticky add to cart */
  function initSticky(scope) {
    each(scope, '[data-pp-sticky]', function (bar) {
      if (!once(bar)) return;
      var atc = document.querySelector('.pp-main [data-pp-codopen]') || document.querySelector('.pp-main [data-pp-atc]');
      var btn = bar.querySelector('[data-pp-sticky-btn]');
      var mode = bar.dataset.ppAction || 'add';
      btn.addEventListener('click', function () {
        if (mode === 'popup') { if (!codOpen() && atc) atc.click(); return; }
        if (isEasySell(btn)) return;
        if (mode === 'scroll') return goTo(bar.dataset.ppGo, bar.dataset.ppSelector || bar.dataset.ppTarget, bar.dataset.ppNth, bar);
        if (atc && !atc.disabled) atc.click();
        else scrollToProduct();
      });
      var footerMode = bar.dataset.ppFooter || 'space';
      var pastAtc = !atc;
      var atFooter = false;
      var bundlesInView = 0;
      function apply() {
        // Hidden while the main button or any bundle offers section is on screen.
        var show = pastAtc && bundlesInView === 0 && !(footerMode === 'hide' && atFooter);
        bar.classList.toggle('is-visible', show || bar.hasAttribute('data-pp-design'));
        // Add room at the very end of the page so the bar never covers the bottom of the footer.
        // A spacer element works even in themes that reset or override body padding.
        var spacer = document.getElementById('pp-sticky-spacer');
        if (show && footerMode === 'space' && !bar.hasAttribute('data-pp-design')) {
          if (!spacer) {
            spacer = document.createElement('div');
            spacer.id = 'pp-sticky-spacer';
            spacer.setAttribute('aria-hidden', 'true');
            spacer.style.cssText = 'display:block;width:100%;flex-shrink:0;grid-column:1/-1;pointer-events:none;';
          }
          spacer.style.height = bar.offsetHeight + 'px';
          if (spacer.parentNode !== document.body || document.body.lastElementChild !== spacer) document.body.appendChild(spacer);
        } else if (spacer) {
          spacer.style.height = '0px';
        }
      }
      if (!('IntersectionObserver' in window)) { pastAtc = true; apply(); return; }
      if (atc) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { pastAtc = !en.isIntersecting && en.boundingClientRect.top < 0; });
          apply();
        }).observe(atc);
      }
      var bundleSeen = new Map();
      var bundleIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bundleSeen.set(en.target, en.isIntersecting); });
        bundlesInView = 0;
        bundleSeen.forEach(function (v) { if (v) bundlesInView++; });
        apply();
      });
      each(document, '[data-pp-anchor="bundles"]', function (sec) { bundleIo.observe(sec); });
      var footer = document.querySelector('footer, .footer, [id$="__footer"], .shopify-section-group-footer-group');
      if (footer && footerMode === 'hide') {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { atFooter = en.isIntersecting; });
          apply();
        }).observe(footer);
      }
      window.addEventListener('resize', apply);
      // Re-check near the bottom of the page in case the theme adds content late (e.g. app widgets).
      window.addEventListener('scroll', function () {
        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200) apply();
      }, { passive: true });
      apply();
    });
  }

  /* Social proof rotator */
  function initSocialProof(scope) {
    each(scope, '[data-pp-sp]', function (bar) {
      if (!once(bar)) return;
      var msgs = bar.querySelectorAll('.pp-sp__msg');
      if (msgs.length < 2) return;
      var secs = Math.max(2, parseFloat(bar.dataset.ppSpInterval) || 3);
      var i = 0;
      setInterval(function () {
        var cur = msgs[i];
        cur.classList.remove('is-on');
        cur.classList.add('is-out');
        setTimeout(function () { cur.classList.remove('is-out'); }, 400);
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, secs * 1000);
    });
  }

  function scrollToTarget(sel) {
    var el = null;
    if (sel) {
      try { el = document.querySelector(sel); } catch (err) { el = null; }
      if (!el) el = document.getElementById(sel.replace(/^#/, ''));
      // Anchor names are saved like Shopify's handleize ("Bundles 2" -> "bundles-2"), so try that too.
      if (!el) el = document.getElementById(sel.replace(/^#/, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''));
    }
    // An anchor name marks the top of its section: scroll the whole section into view.
    if (el && el.classList.contains('pp-anchor-point') && el.parentElement) el = el.parentElement;
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else scrollToProduct();
  }

  /* Scroll-to buttons: data-pp-go = product | bundles | reviews | ... | custom */
  function goTo(where, selector, nth, from) {
    var el = null;
    if (where === 'none') return;
    if (!where || where === 'product') return scrollToProduct();
    if (where === 'custom') return scrollToTarget(selector);
    if (where === 'link') {
      var href = from && from.getAttribute('data-pp-href');
      if (href) window.location.href = href;
      return;
    }
    if (where === 'next') {
      var wrap = from && (from.closest('.shopify-section') || from.closest('section'));
      el = wrap ? wrap.nextElementSibling : null;
      while (el && (el.offsetHeight === 0 || el.tagName === 'SCRIPT' || el.tagName === 'STYLE')) el = el.nextElementSibling;
    } else {
      // Finds sections by type, so new or duplicated sections work without IDs.
      var all = document.querySelectorAll('[data-pp-anchor="' + where + '"]');
      var i = Math.max(1, parseInt(nth, 10) || 1) - 1;
      el = all[Math.min(i, all.length - 1)] || null;
    }
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else if (selector) scrollToTarget(selector);
    else scrollToProduct();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pp-go]:not([data-pp-go=""])');
    if (!b || b.hasAttribute('data-pp-sticky-btn')) return;
    e.preventDefault();
    if (isEasySell(b) || isEasySell(e.target)) return;
    goTo(b.getAttribute('data-pp-go'), b.getAttribute('data-pp-selector'), b.getAttribute('data-pp-nth'), b);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var b = e.target.closest && e.target.closest('[role="link"][data-pp-go]');
    if (b) b.click();
  });

  function scrollToProduct() {
    var target = document.querySelector('.pp-main');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-pp-scroll-product]');
    if (!link) return;
    e.preventDefault();
    scrollToProduct();
  });

  function init(scope) {
    initCarousels(scope);
    initGallery(scope);
    initProduct(scope);
    initCircles(scope);
    initSticky(scope);
    initVideos(scope);
    initSocialProof(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

})();
